import { canUseDOM } from './canUseDOM';
/**
 * @hidden
 */
export function isRtl(element) {
    return Boolean(canUseDOM && element && getComputedStyle(element).direction === 'rtl');
}
